<div>
  <div class="reactivo mat-elevation-z4 p-20 m-20" fxLayout="column" fxLayoutAlign="start stretch">
    <h3>A. ¿Cuántos años en total tienes de ser responsable de gente bajo tu cargo en esta u otras empresas en las que has trabajado?</h3>
    <!-- <mat-form-field>
    <input matInput placeholder="Pregunta nps" formControlName="firstCtrl" required>
  </mat-form-field> -->
  <mat-radio-group aria-label="Select an option" class="example-radio-group">
    <mat-radio-button value="1">No tengo ni he tenido gente bajo mi cargo</mat-radio-button>
    <mat-radio-button value="2">Hasta 2 años</mat-radio-button>
    <mat-radio-button value="3">2 a 5 años</mat-radio-button>
    <mat-radio-button value="4">6 a 10 años</mat-radio-button>
    <mat-radio-button value="5">Más de 10 años</mat-radio-button>
  </mat-radio-group>
  </div>
  <div class="reactivo mat-elevation-z4 p-20 m-20" fxLayout="column" fxLayoutAlign="start stretch">
    <h3> B. ¿Cuál es tu nivel de confianza en las capacidades de los directores de tu empresa?</h3>
    <!-- <mat-form-field>
    <input matInput placeholder="Pregunta nps" formControlName="firstCtrl" required>
  </mat-form-field> -->
  <mat-radio-group aria-label="Select an option"  class="example-radio-group">
    <mat-radio-button value="1">Mucha confianza</mat-radio-button>
    <mat-radio-button value="2">Algo de confianza</mat-radio-button>
    <mat-radio-button value="3">Poca confianza</mat-radio-button>
    <mat-radio-button value="4">Nada de confianza</mat-radio-button>
  </mat-radio-group>
  </div>
  <div class="reactivo mat-elevation-z4 p-20 m-20" fxLayout="column" fxLayoutAlign="start stretch">
    <h3>C. En los últimos 12 meses, ¿cuántas oportunidades has tenido para desarrollar, innovar o crear nuevas o mejores formas de hacer el trabajo?</h3>
    <!-- <mat-form-field>
    <input matInput placeholder="Pregunta nps" formControlName="firstCtrl" required>
  </mat-form-field> -->
  <mat-radio-group aria-label="Select an option"   class="example-radio-group">
    <mat-radio-button value="1">Muchas oportunidades</mat-radio-button>
    <mat-radio-button value="2">Algunas oportunidades</mat-radio-button>
    <mat-radio-button value="3">Pocas oportunidades</mat-radio-button>
    <mat-radio-button value="4">Casi ninguna o ninguna oportunidad</mat-radio-button>
  </mat-radio-group>
  </div>

</div>
